import { useWebsiteBuilder } from '../context/WebsiteBuilderContext';
import DesignTemplate from '../components/DesignTemplate';
import { usePageTracking } from '../../../hooks/usePageTracking';

export default function DesignStepPage() {
  const {
    selectedTemplate, setSelectedTemplate, theme, setTheme, setShowPreview,
    brandName, setBrandName, brandLogo, setBrandLogo,
    globalContactInfo, pages, brandTheme, isExported, triggerChargeConfirm,
  } = useWebsiteBuilder();
  usePageTracking({ moduleName: 'Website Builder', submoduleName: 'Design', routePath: '/website-builder/design' });

  return (
    <DesignTemplate
      selectedTemplate={selectedTemplate}
      onSelectTemplate={setSelectedTemplate}
      theme={theme}
      onThemeChange={setTheme}
      onShowPreview={() => setShowPreview(true)}
      brandName={brandName}
      onBrandNameChange={setBrandName}
      brandLogo={brandLogo}
      onBrandLogoChange={setBrandLogo}
      globalContactInfo={globalContactInfo}
      pages={pages}
      brandTheme={brandTheme}
      isExported={isExported}
      onRequestUnlock={() => triggerChargeConfirm('unlock')}
    />
  );
}
